import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {browserHistory} from 'react-router';
import {put, takeLatest, select, take, call} from 'redux-saga/effects';

import {selectEnv} from 'reducers/env';

import {persist} from '../reducer';

const namespace = 'flows/interest/investor';

// Actions
const LOAD_INTEREST_INVESTOR = defineAction('LOAD_INTEREST_INVESTOR', namespace);
const SUBMIT_INTEREST_INVESTOR = defineAction('SUBMIT_INTEREST_INVESTOR', namespace);

export const loadInterestInvestor = createAction(LOAD_INTEREST_INVESTOR.ACTION);
export const submitInterestInvestor = createAction(SUBMIT_INTEREST_INVESTOR.ACTION);

// Interest Investor Saga
export function* interestInvestorSaga() {
  // TODO: rehydrate investor details from allocation

  // Wait for user to click next
  const action = yield take(SUBMIT_INTEREST_INVESTOR.ACTION);

  // Save should save the investor info to the interest reducer
  yield put(persist({investor: action.payload}));

  // Take them to the next page
  const env = yield select(selectEnv);
  if (env.web) {
    yield call(browserHistory.push, '/interest/accreditation');
  }
}

export function* sagas() {
  yield takeLatest(LOAD_INTEREST_INVESTOR.ACTION, interestInvestorSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/interest/investor/index.js